//Estado por default de Monitoreo
const initialState = {
  intensityList: [],
  loadedIntensityList: false,
};

//Componente Redux para cambiar el estado de Monitoreo
export const monitoringReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_INTENSITY":
      return {
        ...state,
        intensityList: action.payload,
        loadedIntensityList: true,
      };
    default:
      return {
        ...state,
      };
  }
};
